export default __webpack_public_path__ + "static/media/TeamSnap-Banner-Display.9a6a9cb0.png";